import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { getConfig, getMostRecentVCRevision } from '../../config';
import { postInteractionLog } from '../../interaction-metrics';
import { getVCObserver } from '../../vc';
import getInteractionStatus from './get-interaction-status';
import getPageVisibilityUpToTTAI from './get-page-visibility-up-to-ttai';
import getSSRDoneTimeValue from './get-ssr-done-time-value';
function getVCMetrics(_x) {
  return _getVCMetrics.apply(this, arguments);
}
function _getVCMetrics() {
  _getVCMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(interaction) {
    var _config$vc, _config$vc$ssrWhiteli, _interaction$apdex, _config$vc2, _config$experimentalI, _result$ufoVcRev;
    var config, interactionStatus, pageVisibilityUpToTTAI, shouldReportVCMetrics, isSSREnabled, ssr, tti, prefix, result, mostRecentVCRevision, mostRecentVCRevisionPayload;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = getConfig();
          if (config !== null && config !== void 0 && (_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", {});
        case 3:
          if (!(interaction.type !== 'page_load' && interaction.type !== 'transition')) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", {});
        case 5:
          interactionStatus = getInteractionStatus(interaction);
          pageVisibilityUpToTTAI = getPageVisibilityUpToTTAI(interaction);
          shouldReportVCMetrics = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible';
          if (!(!shouldReportVCMetrics && fg('platform_ufo_no_vc_on_aborted'))) {
            _context.next = 11;
            break;
          }
          getVCObserver().stop(interaction.ufoName);
          return _context.abrupt("return", {});
        case 11:
          isSSREnabled = (config === null || config === void 0 ? void 0 : config.ssr) || (config === null || config === void 0 || (_config$vc$ssrWhiteli = config.vc.ssrWhitelist) === null || _config$vc$ssrWhiteli === void 0 ? void 0 : _config$vc$ssrWhiteli.includes(interaction.ufoName));
          ssr = interaction.type === 'page_load' && isSSREnabled ? {
            ssr: getSSRDoneTimeValue(config)
          } : null;
          postInteractionLog.setVCObserverSSRConfig(ssr);
          tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
          prefix = 'ufo';
          _context.next = 18;
          return getVCObserver().getVCResult(_objectSpread({
            start: interaction.start,
            stop: interaction.end,
            tti: tti,
            prefix: prefix,
            vc: interaction.vc,
            isEventAborted: interactionStatus.originalInteractionStatus !== 'SUCCEEDED',
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            includeSSRRatio: (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
          }, ssr));
        case 18:
          result = _context.sent;
          if ((_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) {
            getVCObserver().stop(interaction.ufoName);
          }
          postInteractionLog.setLastInteractionFinishVCResult(result);
          mostRecentVCRevision = getMostRecentVCRevision(interaction.ufoName);
          mostRecentVCRevisionPayload = result === null || result === void 0 || (_result$ufoVcRev = result['ufo:vc:rev']) === null || _result$ufoVcRev === void 0 ? void 0 : _result$ufoVcRev.find(function (_ref) {
            var revision = _ref.revision;
            return revision === mostRecentVCRevision;
          });
          if (!(!shouldReportVCMetrics || !(mostRecentVCRevisionPayload !== null && mostRecentVCRevisionPayload !== void 0 && mostRecentVCRevisionPayload.clean))) {
            _context.next = 25;
            break;
          }
          return _context.abrupt("return", result);
        case 25:
          return _context.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
            'metric:vc90': mostRecentVCRevisionPayload['metric:vc90']
          }));
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getVCMetrics.apply(this, arguments);
}
export default getVCMetrics;